import BaseRouter from "comp/app/Router.js"
import APIClient from "comp/APIClientV2/APIClient"

export default class Router extends BaseRouter {

    async getPageWeb(pParams, pApiResult) {

        if (this.updateModule(
            "PageWeb",
            pParams,
            pApiResult
        )) {
            return
        }

        const modSrc = await import("../pages/Web/Web.js")

        return this.newModule(
            modSrc,
            pParams,
            pApiResult
        )
    }

    async getPageWebHero(pParams, pApiResult) {

        if (this.updateModule(
            "PageWebHero",
            pParams,
            pApiResult
        )) {
            return
        }

        const modSrc = await import("../pages/WebHero/WebHero.js")

        return this.newModule(
            modSrc,
            pParams,
            pApiResult
        )
    }

    async getPage404(pParams) {

        const modSrc = await import("../pages/E404/E404.js")

        return this.newModule(
            modSrc,
            pParams
        )
    }

    constructor(p) {

        super(p)

        this.staticRoutes = {
            "404": this.getPage404,
            "/login": this.getPageLogin,
            "/unathorized": this.getPageUnAuth,
            "/": this.getPageShowcase,
        }

        this.apiModules = {
            "PageWeb": this.getPageWeb,
            "PageWebHero": this.getPageWebHero,
        }
    }
}